import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-location-card',
  templateUrl: './icon-location-card.component.html',
  styles: []
})
export class IconLocationCardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
